import PropTypes from "prop-types";
import SuiDropDownList from "components/SuiDropDownList";
import { statusType } from "./dropdownArrays";

const StatusDropdown = ({ name, value, setValue, handlePostPaidSelection }) => {
  const handleChange = (selectedValue) => {
    setValue(selectedValue);
    handlePostPaidSelection();
  };
  return (
    <SuiDropDownList
      data={statusType}
      select={{
        key: "id",
        valueKey: "id",
        labelName: "label",
        label: "Select Status",
        name: name,
        val: value,
        fn: handleChange,
      }}
    />
  );
};

StatusDropdown.defaultProps = {
  name: "status_type",
};

StatusDropdown.propTypes = {
  name: PropTypes.string,
  value: PropTypes.any,
  setValue: PropTypes.func,
  handlePostPaidSelection: PropTypes.func,
};

export default StatusDropdown;
